'use client';

import { defaultFlagsFor, resolveFlags } from '@/domains/common/feature-flag-defs';
import type { FeatureFlagId, WorkspaceFeatureFlags } from '@/external/db/types';
import { createContext, useContext, useMemo, type FunctionComponent, type ReactNode } from 'react';

export { FEATURE_FLAGS, defaultFlagsFor, resolveFlags } from '@/domains/common/feature-flag-defs';
export type {
  FeatureFlagDef,
  FeatureFlagId,
  WorkspaceFeatureFlags,
} from '@/domains/common/feature-flag-defs';

interface FeatureFlagsState {
  isKpc: boolean;
  flags: WorkspaceFeatureFlags;
}

const FeatureFlagsContext = createContext<FeatureFlagsState>({
  isKpc: false,
  flags: defaultFlagsFor(false),
});

export const FeatureFlagsProvider: FunctionComponent<{
  isKpc: boolean;
  overrides: Partial<WorkspaceFeatureFlags>;
  children: ReactNode;
}> = ({ isKpc, overrides, children }) => {
  const state = useMemo(() => ({ isKpc, flags: resolveFlags(isKpc, overrides) }), [isKpc, overrides]);
  return <FeatureFlagsContext.Provider value={state}>{children}</FeatureFlagsContext.Provider>;
};

export function useIsKpcWorkspace(): boolean {
  return useContext(FeatureFlagsContext).isKpc;
}

export function useFeatureFlag(id: FeatureFlagId): boolean {
  return useContext(FeatureFlagsContext).flags[id];
}
